<template>
	<div>
		<ProfileSelectionDropdown
			v-on="$listeners"
			v-bind="dropdownProps"
			ref="selection-dropdown"
			:showLoadingStatus="showLoadingStatus"
			:readonly="readonly"
			:selectedProjectId="selectedProjectId"
		/>
		<ProfilePermissionExplanation :class="explanationClass" v-if="!hideExplanation" />
		<LockedStepDataProvider
			class="mt-3"
			:key="profileId"
			:profileId="profileId"
			:serviceId="serviceId"
			v-if="showLockedIndication"
			:credentialsType="credentialsType"
		/>
	</div>
</template>
<script>
/**
 * !!!!!!!! IMPORTANT !!!!!!!!!!
 * Whenever we want the user to choose credentials for service, we need to use this component - to keep consistency
 */
import CredentialsService from '@/utils/credentials-service';
import ProfileSelectionDropdown from './ProfileSelectionDropdown.vue';
import ProfilePermissionExplanation from './ProfilePermissionExplanation.vue';
import { isNullOrUndefined } from '@/utils/helpers';
import { isConfigurationsOn } from '@/store/modules/featureFlags/getters';
import LockedStepDataProvider from '@/components/BlockEditor/LockedStep/LockedStepDataProvider.vue';
import { mapGetters } from 'vuex';
import { CredentialsTypes } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'ProfileSelector',
	components: {
		ProfileSelectionDropdown,
		ProfilePermissionExplanation,
		LockedStepDataProvider,
	},
	props: {
		showLockedIndication: { type: Boolean },
		profileId: { type: Number },
		serviceId: { type: Number },
		selectedProjectId: { type: Number },
		serviceVersionId: { type: String },
		readonly: { type: Boolean, default: false },
		nativeIntegrationAccount: { type: Boolean, default: false },
		includeVirtualProfiles: { type: Boolean, default: false },
		credentialsType: { type: String, default: CredentialsTypes.Embedded },
		configurationFieldProps: { type: Object },
		disableRealProfiles: { type: Boolean, default: false },
		showLoadingStatus: { type: Boolean, default: false },
		customFieldProps: { type: Object },
		hideExplanation: { type: Boolean, default: false },
		shouldOpenProjectOptions: { type: Boolean, default: true },
		includeProjectRelatedConnections: { type: Boolean, default: true },
		readOnlyCred: { type: Object },
	},
	computed: {
		...mapGetters([isConfigurationsOn.fullPath]),
		showConfigurationSection() {
			return (
				this[isConfigurationsOn.fullPath] &&
				this.includeVirtualProfiles &&
				CredentialsService.isConnectionFromConfiguration(this.credentialsType)
			);
		},
		dropdownProps() {
			return { ...this.$props, includeVirtualProfiles: this.includeVirtualProfiles && this[isConfigurationsOn.fullPath] };
		},
		explanationClass() {
			const classes = [];
			// by default, ProfileSelectionDropdown applies hideDetails prop, so if not specified, behave like hideDetails is applied
			const defaultHideDetailsWillApply =
				isNullOrUndefined(this.customFieldProps?.hideDetails) && isNullOrUndefined(this.customFieldProps?.['hide-details']);
			const needToMarginTop = this.customFieldProps?.hideDetails || this.customFieldProps?.['hide-details'] || defaultHideDetailsWillApply;
			if (needToMarginTop) {
				classes.push('mt-2');
			}
			return classes;
		},
	},
	methods: {
		reconnectProfile() {
			this.$refs['selection-dropdown'].reconnectProfile();
		},
		forceReconnectProfile() {
			this.$refs['selection-dropdown'].forceReconnectProfile();
		},
		forceAddProfile() {
			this.$refs['selection-dropdown'].addProfile();
		},
	},
};
</script>
<style scoped lang="scss">
::v-deep {
	.locked-step-by-you-container {
		background: var(--light-bg-color) !important;
	}
}
</style>
